// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020604/js/" + chunkId + "." + {"44":"eadf987e","225":"ea493262","481":"d355e89b","486":"188b6dec","770":"655a5194"}[chunkId] + ".0.4294850407989891.chunk.js";
};